<template>
  <section class="bg-light py-4">
    <div class="container">
      <div class="row">
        <div class="col-md-3 col-lg-2 mb-3 mb-md-0">
          <a href="/dashboard" class="btn btn-link"><span
              class="far fa-long-arrow-left pr-2"></span>Terug</a>
        </div>
        <div class="col-md-9 col-lg-8">
          <div class="card card-blue mb-4">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h1 class="h2">Arbeidsongeschikt melden</h1>
            </div>
            <div class="card-body">
              <p>Je kan aangeven dat je arbeidsongeschikt bent via onderstaand formulier. Wij ontvangen direct een mail
                met je
                gegevens en de startdatum van de ziekteperiode.</p>
              <form @submit.prevent="submit" method="post">

                <h2>Persoonlijke gegevens</h2>
                <div class="custom-control custom-checkbox mb-3" :class="{ 'has-invalid': $v.checkboxNAW.$error }">
                  <input type="checkbox" id="checkbox-naw" class="custom-control-input" v-model="checkboxNAW">
                  <label for="checkbox-naw" class="custom-control-label">Onderstaande adresgegevens kloppen en zijn
                    actueel. <i class="far fa-info-circle" v-tooltip="{content: 'Pas je adresgegevens eventueel aan op je profiel.'}"></i></label>
                </div>
                <div class="card mb-3">
                  <div class="card-body">
                    {{ address.name }}<br>
                    {{ address.straat }}<br>
                    {{ address.postcode }} {{ address.plaats }}<br>
                    {{ address.telefoon }}<br>
                  </div>
                </div>
                <h2>Overige vragen</h2>
                <div class="custom-control custom-checkbox mb-3" :class="{ 'has-invalid': $v.checkboxInfo.$error }">
                  <input type="checkbox" id="checkbox-info" class="custom-control-input"
                         v-model="$v.checkboxInfo.$model" @focus="$v.checkboxInfo.$reset">
                  <label for="checkbox-info" class="custom-control-label">Ik geef toestemming aan Socialtens om mijn
                    persoonsgegevens inclusief mijn financiële en medische gegevens te verwerken.
                  <i class="far fa-info-circle" v-tooltip="{content: tooltip, html: true, trigger: 'click'}"></i>
                  </label>
                </div>
                <div class="custom-control custom-checkbox mb-3" :class="{ 'has-invalid': $v.checkboxDoctor.$error }">
                  <input type="checkbox" id="checkbox-doctor" class="custom-control-input"
                         v-model="$v.checkboxDoctor.$model" @focus="$v.checkboxDoctor.$reset">
                  <label for="checkbox-doctor" class="custom-control-label">Ik machtig hierbij de bedrijfsarts voor het
                    opvragen en verwerken van mijn gegevens.</label>
                </div>
                <div class="custom-control custom-checkbox mb-3">
                  <input type="checkbox" id="checkbox-visit-doctor" class="custom-control-input"
                         v-model="checkboxVisitDoctor">
                  <label for="checkbox-visit-doctor" class="custom-control-label">Ik ben fysiek in staat om een
                    bedrijfsarts te bezoeken.</label>
                </div>
                <div class="custom-control custom-checkbox mb-3">
                  <input type="checkbox" id="checkbox" class="custom-control-input" v-model="checkboxLong">
                  <label for="checkbox" class="custom-control-label">Ik verwacht langer dan 4 weken arbeidsongeschikt te
                    zijn.</label>
                </div>
                <div v-if="isWoman" class="custom-control custom-checkbox mb-3">
                  <input type="checkbox" id="checkbox-pregnancy" class="custom-control-input"
                         v-model="checkboxPregnancy">
                  <label for="checkbox-pregnancy" class="custom-control-label">Er is sprake van een zwangerschap (of
                    -verlof)</label>
                </div>

                <div class="form-group" :class="{ 'has-invalid': $v.profession.$error }">
                  <label for="text-profession">Wat is je beroep of bedrijf?</label>
                  <textarea name="message" id="text-profession" rows="4" class="form-control"
                            v-model.trim.lazy="$v.profession.$model"
                            @focus="$v.profession.$reset"></textarea>
                </div>
                <div class="form-group" :class="{ 'has-invalid': $v.work.$error }">
                  <label for="text-work">Welke soort werkzaamheden verricht je en voor hoeveel uur?</label>
                  <textarea name="message" id="text-work" rows="4" class="form-control"
                            v-model.trim.lazy="$v.work.$model"
                            @focus="$v.work.$reset"></textarea>
                </div>
                <button type="button" class="btn btn-primary" @click="submit()">Ik ben arbeidsongeschikt</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import mustBeTrue from '../js/validators/mustBeTrue';
import {required} from 'vuelidate/lib/validators';

export default {
    props: {
        route: String,
        address: Object,
        isWoman: Boolean,
        sickProp: Boolean,
    },
    data() {
        return {
            tooltip: this.$root.registration.tooltip,
            sick: this.sickProp,
            checkboxLong: false,
            checkboxVisitDoctor: false,
            checkboxDoctor: false,
            checkboxInfo: false,
            checkboxNAW: false,
            checkboxPregnancy: false,
            processing: false,
            profession: '',
            work: '',
        };
    },
    validations() {
        return {
            checkboxDoctor: {
                mustBeTrue,
            },
            checkboxInfo: {
                mustBeTrue,
            },
            checkboxNAW: {
                mustBeTrue,
            },
            profession: {
                required,
            },
            work: {
                required,
            }
        };
    },
    methods: {
        submit() {
            this.$v.$touch();

            if (this.processing) {
                return false;
            }

            this.processing = true;

            let that = this;

            this.axios.post(this.route, {
                long: this.checkboxLong,
                allowDoctor: this.checkboxDoctor,
                allowCollectInfo: this.checkboxInfo,
                allowNAW: this.checkboxNAW,
                visitDoctor: this.checkboxVisitDoctor,
                pregnancy: this.checkboxPregnancy,
                profession: this.profession,
                work: this.work,
            })
                .then(() => {
                    that.sick = true;

                    that.$notify({
                        group: 'base',
                        text: 'Je melding is geregistreerd.',
                        type: 'alert-info',
                    });

                    // return to dashboard
                    window.location = '/dashboard';
                })
                .catch(error => {
                    let msg = 'Er is een fout opgetreden.';
                    if (error.response.data.errors.allowNAW || error.response.data.errors.allowCollectInfo || error.response.data.errors.allowDoctor) {
                        msg = 'Je dient akkoord te gaan met alle verplichte velden.';
                    }

                    that.$notify({
                        group: 'base',
                        text: msg,
                        type: 'alert-danger',
                    });
                });

            this.processing = false;
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/components/ZiekMeldenPage.vue